import React, { useEffect, useState } from 'react'
import { CRow, CCol, CCard, CCardBody, CButton, CAlert } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCloudUpload, cilPlus, cilCalendar, cilCalendarCheck } from '@coreui/icons'
import { useNavigate } from 'react-router-dom'
import Table from './Table'
import AddForm from './AddForm'
import AddFormForLeagueIndoorFixture from './AddFormForLeagueIndoorFixture'
import EditForm from './EditForm'
import FixtureService from 'src/service/FixtureService'
import CommonService from 'src/service/CommonService'
import PreviewRoundTable from 'src/views/Round/PreviewRoundTable'

const Fixture = () => {
  const navigate = useNavigate()
  const [displayDetails, setDisplayDetails] = useState([])
  const [users, setUsers] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(50)
  const [loading, setLoading] = useState(false)
  const [gameType, setGameType] = useState()
  const [addFixtureVisible, setAddFixtureVisible] = useState(false)
  const [editFixtureId, setEditFixtureId] = useState(null)
  const [roundPreviewVisible, setRoundPreviewVisible] = useState(false)

  var columns = [
    {
      label: 'FID',
      key: 'id',
      _style: { width: '10%' },
    },
    {
      key: 'round',
    },
    {
      label: 'Team',
      key: 'team_name',
    },
    { label: 'Type', key: 'match_type', filter: false, sorter: false },
    { label: 'Start Date', filter: false, key: 'start_date' },
    { label: 'Start Time', filter: false, key: 'start_time' },
    { label: 'Status', filter: false, key: 'status' },
    {
      key: 'display',
      label: 'Display',
      filter: false,
      sorter: false,
    },
    {
      key: 'actions',
      label: 'Actions',
      filter: false,
      sorter: false,
    },
  ]
  if (gameType !== 1) {
    columns = [
      {
        label: 'FID',
        key: 'id',
        _style: { width: '10%' },
      },
      {
        key: 'round',
      },
      {
        label: 'Home Team',
        key: 'team_name',
      },
      {
        label: 'Away Team',
        key: 'team2_name',
      },
      { label: 'Type', key: 'match_type', filter: false, sorter: false },
      { label: 'Start Date', filter: false, key: 'start_date' },
      { label: 'Start Time', filter: false, key: 'start_time' },
      { label: 'Status', filter: false, key: 'status' },
      {
        key: 'display',
        label: 'Display',
        filter: false,
        sorter: false,
      },
      {
        key: 'actions',
        label: 'Actions',
        filter: false,
        sorter: false,
      },
    ]
  }

  const fetchData = (activePage, columnFilter, columnSorter, itemsPerPage) => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    FixtureService.getFixture(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  useEffect(() => {
    FixtureService.getActivatedDisplay()
      .then((res) => {
        if (res.status === 200) {
          setDisplayDetails(res.data)
        }
      })
      .then(() => {
        CommonService.getGameType().then((res) => {
          if (res.status === 200) {
            setGameType(res.data)
          }
        })
      })
  }, [])

  return (
    <>
      <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
        <div className="d-flex flex-wrap gap-2">
          <CButton color="secondary" variant="outline" onClick={() => navigate('/fixture-import')}>
            <CIcon icon={cilCloudUpload} className="me-1" />
            Import Fixtures
          </CButton>
          <CButton color="secondary" variant="outline" onClick={() => setRoundPreviewVisible(true)}>
            <CIcon icon={cilCalendar} className="me-1" />
            Preview Rounds
          </CButton>
          {gameType && (
            <CButton color="primary" onClick={() => setAddFixtureVisible(true)}>
              <CIcon icon={cilPlus} className="me-1" />
              Add Fixture
            </CButton>
          )}
        </div>
      </div>

      {gameType == 4 && (
        <CAlert color="danger">Restriction: You can create a maximum of 1 Fixture only</CAlert>
      )}

      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Fixtures</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilCalendarCheck} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard>
        <CCardBody>
          <Table
            columns={columns}
            displayDetails={displayDetails}
            setDisplayDetails={setDisplayDetails}
            users={users}
            activePage={activePage}
            setActivePage={setActivePage}
            columnFilter={columnFilter}
            setColumnFilter={setColumnFilter}
            columnSorter={columnSorter}
            setColumnSorter={setColumnSorter}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            fetchData={fetchData}
            setLoading={setLoading}
            loading={loading}
            gameType={gameType}
            onEditFixture={setEditFixtureId}
          />
        </CCardBody>
      </CCard>

      {(gameType === 1 || gameType === 4) && (
        <AddForm
          visible={addFixtureVisible}
          onClose={() => setAddFixtureVisible(false)}
          gameType={gameType}
          activePage={activePage}
          columnFilter={columnFilter}
          columnSorter={columnSorter}
          itemsPerPage={itemsPerPage}
          fetchData={fetchData}
        />
      )}
      {(gameType === 2 || gameType === 3) && (
        <AddFormForLeagueIndoorFixture
          visible={addFixtureVisible}
          onClose={() => setAddFixtureVisible(false)}
          activePage={activePage}
          columnFilter={columnFilter}
          columnSorter={columnSorter}
          itemsPerPage={itemsPerPage}
          fetchData={fetchData}
        />
      )}

      <EditForm
        fixtureId={editFixtureId}
        visible={!!editFixtureId}
        onClose={() => setEditFixtureId(null)}
        gameType={gameType}
        activePage={activePage}
        columnFilter={columnFilter}
        columnSorter={columnSorter}
        itemsPerPage={itemsPerPage}
        fetchData={fetchData}
      />

      <PreviewRoundTable
        visible={roundPreviewVisible}
        onClose={() => setRoundPreviewVisible(false)}
      />
    </>
  )
}

export default Fixture
